import { useState } from "react";
import { Box, Button, useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../theme";
import { useHideMode } from "../theme";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import saveTransactions from "./managers/saveTransactions";
import Fade from '@mui/material/Fade';




const RecentTransactions = (transactions, handleClick) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const hideTheme = useHideMode();


    function handleRenderCell(params, formatValue = false, formatUSD = false) {
        const colName = params.colDef.field;
        const { id, value, api } = params;

        const getCellStyle = () => {
            let color = api.getRow(id).trans_type === "EXPENSE" ? colors.redAccent[400] : colors.greenAccent[400];
            color = api.getRow(id).trans_type === "TRANSFER" ? "#F9A825" : color;
            return { color };
        };

        const getFormattedValue = () => {
            if (!formatValue) {
                return value;
            }
            let amount = value / 100000000;
            amount = (formatUSD) ? amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : amount
            return amount
        };

        return (
            <div style={getCellStyle()}>
                {(hideTheme.mode === "hide" && (colName === "amount" || colName === "crypto_amount")) ? '*'.repeat(9) : getFormattedValue()}
            </div>
        );
    }



    const recentTransactionsColumns = [
        {
            field: "confirm",
            renderCell: (cellValues) => {
                return (
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={(event) => {
                            handleClick(event, cellValues);
                        }}
                    >
                        Confirm
                    </Button>
                )
            },
            headerName: "Confirm",
            headerAlign: 'center',
            align: 'center',
            width: 150,
        },
        {
            field: "transaction_date",
            headerName: "Date",
            headerAlign: 'center',
            width: 100,
            align: 'center',
            cellClassName: "number",
            editable: true,
            valueFormatter: (params) => {
                const date = new Date(params.value * 1000); // convert Unix timestamp to milliseconds
                const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
                return formattedDate;
            }
        },
        {
            field: "amount",
            headerName: "Amount",
            headerAlign: 'center',
            width: 100,
            align: 'right',
            cellClassName: "number",
            editable: true,
            renderCell: (params) => handleRenderCell(params, true, true),
        },
        {
            field: "trans_type",
            headerName: "Type",
            headerAlign: 'center',
            width: 100,
            align: 'center',
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },
        {
            field: "source",
            headerName: "Source",
            headerAlign: 'center',
            width: 200,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },
        {
            field: "description",
            headerName: "Description",
            headerAlign: 'center',
            width: 400,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },
        {
            field: "category",
            headerName: "Category",
            headerAlign: 'center',
            width: 150,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },
        {
            field: "subcategory",
            headerName: "Subcategory",
            headerAlign: 'center',
            width: 150,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "app_account",
            headerName: "Account",
            headerAlign: 'center',
            width: 100,
            align: 'center',
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "money_account",
            headerName: "Money Account",
            headerAlign: 'center',
            align: 'left',
            width: 350,
            align: 'left',
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "bucket",
            headerName: "Bucket",
            headerAlign: 'center',
            align: 'left',
            width: 250,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "sub_bucket",
            headerName: "SubBucket",
            headerAlign: 'center',
            align: 'left',
            width: 250,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "hsa_expense",
            headerName: "HSA Expense",
            headerAlign: 'center',
            width: 150,
            align: 'center',
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "income_type",
            headerName: "Income Type",
            headerAlign: 'center',
            width: 150,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "income_source",
            headerName: "Income Source",
            headerAlign: 'center',
            width: 150,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "is_subscription",
            headerName: "Is Subscription",
            headerAlign: 'center',
            width: 150,
            align: 'center',
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "crypto_amount",
            headerName: "Crypto Amount",
            headerAlign: 'center',
            width: 150,
            align: 'right',
            editable: true,
            renderCell: (params) => handleRenderCell(params, true, false),
        },

        {
            field: "currency",
            headerName: "Currency",
            headerAlign: 'center',
            align: 'center',
            width: 200,
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "transaction_source",
            headerName: "Transaction Source",
            headerAlign: 'center',
            width: 150,
            align: 'left',
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },

        {
            field: "notes",
            headerName: "Notes",
            headerAlign: 'center',
            width: 500,
            align: 'left',
            editable: true,
            renderCell: (params) => handleRenderCell(params, false, false),
        },









    ];

    return (

        <Box
            m="20px 0 0 0"
            height="79.4%"
            sx={{
                "& .MuiDataGrid-root": {
                    border: "none",
                },
                "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                },
                "& .name-column--cell": {
                    color: colors.greenAccent[300],
                },
                "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: colors.blueAccent[400],
                    borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                    backgroundColor: colors.primary[400],
                },
                "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: colors.blueAccent[400],
                },
                "& .MuiCheckbox-root": {
                    color: `${colors.greenAccent[200]} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[100]} !important`,
                },
            }}
        >



            {/* CONDITIONAL RECENT TRANSACTIONS */}
            < DataGrid

                rows={transactions}
                columns={recentTransactionsColumns}
                components={{
                    Toolbar: GridToolbar,

                }}
                sx={
                    {
                        fontSize: 15,
                        '& .MuiDataGrid-cell:edit': {
                            fontSize: 10,
                        },
                        CanUserResizeColumns: true,
                    }

                }
            // checkboxSelection
            //onRowClick={handleRowClick}
            />

        </Box>

    )
};


export default RecentTransactions;


